import { render, staticRenderFns } from "./EditorHead.vue?vue&type=template&id=d2173138&scoped=true&"
import script from "./EditorHead.vue?vue&type=script&lang=js&"
export * from "./EditorHead.vue?vue&type=script&lang=js&"
import style0 from "./EditorHead.vue?vue&type=style&index=0&id=d2173138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2173138",
  null
  
)

export default component.exports